import React from 'react';
import { audiences } from '../data/content';
import { CtaButton } from './CtaButton';
export function AudienceSection() {
  return <section className="bg-white px-4 py-6 md:px-12 md:py-8" data-id="element-1" data-mp="mzx4o3sdofxu">
      <h2 className="mx-auto max-w-[600px] text-center text-[22px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[30px]" data-id="element-2" data-mp="s02x3m6h26gz">
        ¿Para quién está diseñado?
      </h2>
      <ul className="mt-4 divide-y divide-slate-200 border-y border-slate-200" data-id="element-3" data-mp="3vi30eo131no9">
        {audiences.map(a => <li key={a.title} className="grid gap-1 py-3 md:grid-cols-[240px_1fr] md:gap-6" data-id="element-4" data-mp="4c1tmro5hg8f">
            <h3 className="text-[14px] font-extrabold uppercase leading-tight text-teal-700 md:text-[15px]" data-id="element-5" data-mp="9923ldo4f34t">
              {a.title}
            </h3>
            <p className="text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-6" data-mp="e2mt0hbneose">{a.text}</p>
          </li>)}
      </ul>
      <p className="mt-3 text-center text-[12px] italic leading-snug text-slate-500 md:text-[13px]" data-id="element-7" data-mp="3hpdc2cy306nz">
        Material de nivel profesional. Requiere evaluación clínica y conocimientos previos.
      </p>
      <div className="mt-5 text-center" data-id="element-8" data-mp="zb7phpv95hhe">
        <p className="text-[15px] font-extrabold uppercase leading-tight text-blue-950 md:text-[17px]" data-id="element-9" data-mp="zc98qhmf9aa7">
          ¿Te reconociste en esta lista?
        </p>
        <div className="mt-2.5" data-id="element-10" data-mp="qjxnda660d13">
          <CtaButton mode="scroll" subtext="Sumá las 440 páginas a tu práctica hoy mismo" data-id="element-11" data-mp="qiw9kxxrlcfo">
            ¡Sí, es para mí! Quiero ver la oferta
          </CtaButton>
        </div>
      </div>
    </section>;
}